import { cBasketCustomValidationTranslations } from '@epicuro-next/constants/features/localization';
import { messageToTranslatedOrOriginal } from '@epicuro-next/utilities';

export const basketValidationToTranslated = messageToTranslatedOrOriginal(
  cBasketCustomValidationTranslations,
);
